import BUYMANUAL from "../components/home/BuyManual";

function BuyManual() {
  return <BUYMANUAL />;
}

export default BuyManual;
